// Migrated from app/assets/javascripts/orange2.js (inline code section)
// Orange2 layout: seatplan scaling, panels, modals, tooltips, idle, intlTelInput init

import 'jquery'

history.navigationMode = 'compatible';

// Iframe detection function
function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

var cwidth, cheight, cratio, sp_timeout = false, collapse_timeout = false;

function scaleSeatPlanTimed() {
  if (sp_timeout !== false)
    clearTimeout(sp_timeout);
  sp_timeout = setTimeout(function() {
    scaleSeatPlan();
  }, 100);
}
window.scaleSeatPlanTimed = scaleSeatPlanTimed;

function scaleSeatPlan() {
  if (typeof cwidth == "undefined") {
    cwidth = parseInt($(".kineticjs-content canvas:first").attr("width"));
    cheight = parseInt($(".kineticjs-content canvas:first").attr("height"));
    cratio = cwidth / cheight;
  }
  var width_to_set = $(".kineticjs-content").parents("div:first").width();
  if (width_to_set > cwidth) {
    width_to_set = cwidth;
  }
  $(".kineticjs-content canvas, .kineticjs-content").animate({
    "width": width_to_set + 'px',
    "height": Math.ceil(cratio * width_to_set) + 'px'
  }, 100);
  if (width_to_set < cwidth && $(".seatplan_large_link").length === 0) {
    var $modalLink = $("<a class=\"seatplan_large_link btn btn-default\" data-toggle=\"modal\" data-target=\"#largeSeatPlan\" href=\"javascript:;\">Klik voor een grote plattegrond</a>");

    $("#container").append($modalLink);
    $('#largeSeatPlan').on('shown.bs.modal', function(e) {
      $(".kineticjs-content").css({
        width: 'auto',
        height: 'auto'
      });
      $("#container .kineticjs-content").appendTo("#largeSeatPlan .modal-body");
      scaleSeatPlanTimed();
    });
    $('#largeSeatPlan').on('hidden.bs.modal', function(e) {
      $("#largeSeatPlan .modal-body .kineticjs-content").prependTo("#container");
      scaleSeatPlanTimed();
    });
  } else if (width_to_set < cwidth) {
    $(".seatplan_large_link").show();
  } else {
    $(".seatplan_large_link").hide();
  }
}
window.scaleSeatPlan = scaleSeatPlan;

function resizePanesTimed() {
  if (collapse_timeout !== false)
    clearTimeout(collapse_timeout);
  collapse_timeout = setTimeout(resizePanes, 200);
}

function resizePanes() {
  var dragging = false;
  $("body").on("touchmove", function(){
    dragging = true;
  }).on("touchstart", function(){
    dragging = false;
  });
  if (true) {
    $('#btn-pay').removeClass('btn-block');
    $('.main-panel').each(function() {
      var $panel = $(this);
      var $collapse = $panel.find('.main-panel-collapse').first();
      if ($panel.hasClass('active')) {
        $collapse.collapse({ toggle: false }).collapse('show');
      } else {
        $collapse.collapse({ toggle: false }).collapse('hide');
      }
    });

    // Scroll naar het actieve panel als het niet het eerste is (bv. cancel-redirect)
    var $allPanels = $('.main-panel');
    var $activePanel = $allPanels.filter('.active').first();
    if ($activePanel.length && $allPanels.index($activePanel) > 0) {
      setTimeout(function() {
        $activePanel[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }

    $(".main-panel > .panel-heading").click(function() {
      if (!dragging){
        var $panel = $(this).closest('.panel');
        var $target = $($(this).attr('href'));

        if($panel.hasClass('active')){
          $panel.removeClass('active');
          $(this).attr('aria-expanded', 'false');
          $target.collapse({
            toggle: false
          }).collapse('hide');
        } else {
          var allPreviousCompleted = true;
          var $allPanels = $('.main-panel');
          var clickedIndex = $allPanels.index($panel);

          $allPanels.each(function(index) {
            if (index < clickedIndex) {
              if (!$(this).hasClass('completed')) {
                allPreviousCompleted = false;
                return false;
              }
            }
          });

          if (!allPreviousCompleted) {
            $panel.addClass('blocked-shake');
            setTimeout(function() {
              $panel.removeClass('blocked-shake');
            }, 600);
            return false;
          }

          $('.panel').removeClass('active');
          $panel.addClass('active');
          $('.main-panel > .panel-heading').attr('aria-expanded', 'false');
          $(this).attr('aria-expanded', 'true');
          $('.main-panel-collapse.panel-collapse').collapse({
            toggle: false
          }).collapse('hide');
          $target.collapse({
            toggle: false
          }).collapse('show');
        }
      }
    });

    $(".btn-next-panel").click(function() {
      if ($(this).prop('disabled') || $(this).hasClass('disabled')) {
        return false;
      }

      var $activePanel = $('.main-panel.active');
      var canProceed = true;

      if ($activePanel.length > 0 && typeof window.validatePanelOnLeave === 'function') {
        var panelId = $activePanel.attr('id');
        canProceed = window.validatePanelOnLeave(panelId);
      }

      if (!canProceed) {
        return false;
      }

      $('.main-panel-collapse.panel-collapse').collapse({
        toggle: false
      }).collapse('hide');
      $('.panel').removeClass('active');
      $('.main-panel > .panel-heading').attr('aria-expanded', 'false');
      var next_id = $(this).data('next');
      var $nextPanel = $('#panel_'+next_id);
      $nextPanel.collapse({
        toggle: false
      }).collapse('show').closest('.panel').addClass('active');
      $nextPanel.closest('.panel').find('.panel-heading').attr('aria-expanded', 'true');

      setTimeout(function() {
        var panelElement = $nextPanel.closest('.panel')[0];
        if (panelElement) {
          panelElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        $nextPanel.find('[data-toggle="tooltip"]').tooltip();
      }, 350);
    });

    $(".btn-prev-panel").click(function() {
      $('.main-panel-collapse.panel-collapse').collapse({
        toggle: false
      }).collapse('hide');
      $('.panel').removeClass('active');
      $('.main-panel > .panel-heading').attr('aria-expanded', 'false');
      var next_id = $(this).data('next');
      var $nextPanel = $('#panel_'+next_id);
      $nextPanel.collapse({
        toggle: false
      }).collapse('show').closest('.panel').addClass('active');
      $nextPanel.closest('.panel').find('.panel-heading').attr('aria-expanded', 'true');

      setTimeout(function() {
        var panelElement = $nextPanel.closest('.panel')[0];
        if (panelElement) {
          panelElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        $nextPanel.find('[data-toggle="tooltip"]').tooltip();
      }, 350);
    });
  } else {
    $('#btn-pay').addClass('btn-block');
    $('.main-panel-collapse.panel-collapse').collapse({
      toggle: false
    }).collapse('show');
  }
}

$(document).ready(function() {

  // Patch Bootstrap tooltip to gracefully handle hidden elements
  if ($.fn.tooltip) {
    var originalShow = $.fn.tooltip.Constructor.prototype.show;
    $.fn.tooltip.Constructor.prototype.show = function() {
      if (this.element && !$(this.element).is(':visible')) {
        return;
      }
      try {
        return originalShow.apply(this, arguments);
      } catch (e) {
        if (e.message && e.message.indexOf('visible elements') === -1) {
          throw e;
        }
      }
    };
  }

  var windowWidth = $(window).width();
  $(window).resize(function(){
    if ($(window).width() != windowWidth) {
      windowWidth = $(window).width();
      scaleSeatPlanTimed();
    }
  });
  resizePanes();
  scaleSeatPlanTimed();

  // Iframe detection and adjustments
  if (inIframe()) {
    $('body').addClass('iframe');

    var urlParams = new URLSearchParams(window.location.search);
    var previewParam = urlParams.get('preview');
    if (previewParam && previewParam.startsWith('1')) {
      $('body').addClass('preview-mode');
    }

    var $serviceButton = $('.orange2-service-button');
    var $eventTitle = $('.orange2-event-header .event-title');

    if ($serviceButton.length > 0 && $eventTitle.length > 0) {
      $serviceButton.addClass('service-in-title');
      $eventTitle.append($serviceButton);
    }
  }

  // ACCORDION
  $("body").on("click", "button.accordion-toggle", function() {
    if(!$(this).closest('.panel').hasClass('active')){
      $('.panel').removeClass('active');
      $(this).closest('.panel').addClass('active');
    }
    else {
      $(this).closest('.panel').removeClass('active');
    }
  });

  $("#panelOneB").on("shown.bs.collapse", function(e) {
    scaleSeatPlanTimed();
  });

  setTimeout(function() {
    $('[data-toggle="tooltip"]').tooltip();
  }, 1500);

  // Re-initialize tooltips when panels are opened
  $('.main-panel-collapse').on('shown.bs.collapse', function() {
    $(this).find('[data-toggle="tooltip"]').tooltip();
  });

  $("#phone").intlTelInput({
    initialCountry: 'auto',
    geoIpLookup: function(callback) {
      $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
        var countryCode = (resp && resp.country) ? resp.country : "";
        callback(countryCode);
      });
    },
    utilsScript: "https://storage.googleapis.com/avayo-production/vendor/intl-tel-input/build/js/utils.js"
  });

  // Remove flag dropdown from tab order
  $(".selected-flag").attr("tabindex", "-1");

  // Handle all modal triggers with AJAX content loading
  $('body').on('click', 'a[data-toggle="modal"]', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var $link = $(this);
    var modalId = $link.data('target');
    var modalUrl = $link.attr('href');

    var $dropdown = $link.closest('.dropdown-menu').siblings('[data-toggle="dropdown"]');
    if ($dropdown.length) {
      $dropdown.dropdown('toggle');
    }

    var delay = $dropdown.length ? 100 : 0;
    setTimeout(function() {
      if (modalUrl && modalUrl !== '#' && modalUrl !== '') {
        $(modalId + ' .modal-content').load(modalUrl, function() {
          $(modalId).modal('show');
        });
      } else {
        $(modalId).modal('show');
      }
    }, delay);

    return false;
  });

  // Sale countdown timer
  var $countdownPanel = $('.sale-countdown-panel');
  if ($countdownPanel.length > 0) {
    var saleStartsTimestamp = parseInt($countdownPanel.data('sale-starts'));
    var loadingText = $countdownPanel.data('loading-text');
    var countdownInterval;

    function updateCountdown() {
      var now = new Date().getTime();
      var distance = saleStartsTimestamp - now;

      if (distance <= 1000) {
        clearInterval(countdownInterval);

        $countdownPanel.html('<div class="countdown-loading">' +
          '<div class="spinner"></div>' +
          '<h3>' + loadingText + '</h3>' +
          '</div>');

        var reloadDelay = Math.max(0, distance);
        setTimeout(function() {
          window.location.reload();
        }, reloadDelay);
        return;
      }

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      $('#days').text(String(days).padStart(2, '0'));
      $('#hours').text(String(hours).padStart(2, '0'));
      $('#minutes').text(String(minutes).padStart(2, '0'));
      $('#seconds').text(String(seconds).padStart(2, '0'));
    }

    updateCountdown();
    countdownInterval = setInterval(updateCountdown, 1000);
  }

});
